import { render, staticRenderFns } from "./AllEmailTemplates.vue?vue&type=template&id=a6c04f98&scoped=true&"
import script from "./AllEmailTemplates.vue?vue&type=script&lang=js&"
export * from "./AllEmailTemplates.vue?vue&type=script&lang=js&"
import style0 from "./AllEmailTemplates.vue?vue&type=style&index=0&id=a6c04f98&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6c04f98",
  null
  
)

export default component.exports